// Generated by purs version 0.15.0
import * as $foreign from "./foreign.js";
import * as Control_Monad from "../Control.Monad/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
var traceValue = function (dictMonadEffect) {
    return function (dictEncode) {
        return function (name) {
            return function (value) {
                return Effect_Class.liftEffect(dictMonadEffect)($foreign.traceValue_(name)(Foreign_Generic_Class.encode(dictEncode)(value)));
            };
        };
    };
};
var ifTracing = function (dictMonadEffect) {
    return Control_Monad.whenM(dictMonadEffect.Monad0())(Effect_Class.liftEffect(dictMonadEffect)($foreign.isTracing));
};
export {
    traceValue_,
    isTracing
} from "./foreign.js";
export {
    traceValue,
    ifTracing
};
//# sourceMappingURL=index.js.map
